// EPOD dealer-facing display labels - user_type-aware, config-driven, with a mandatory fallback
// chain. This project's existing config modules (dealerConfirmationConfig.js etc.) are all
// backend-polled business-rule configs (SLA hours, thresholds, feature flags) - there is no
// existing UI-text-label config anywhere in this codebase (constants.js is a flat key->string map
// with no user_type awareness). Rather than invent a new backend-polled config service for a
// single cosmetic label, this stays a small, local, additive config object - proportionate to the
// actual requirement (one label, no runtime admin-editable need stated anywhere in the task).
//
// Resolution order, exactly as specified:
//   1. A user_type-specific override for this label key, if one exists.
//   2. Otherwise, the label's own default.
//   3. If the label key itself is missing from config entirely, the hardcoded default below.
const DEFAULT_LABEL_CONFIG = {
    labels: {
        pending_to_upload: {
            default: 'Pending To Upload',
            user_type_overrides: {
                CUSTOMER: 'Pending for Review',
            },
        },
    },
};

function getDisplayLabel(labelKey, userType, config) {
    var cfg = config || DEFAULT_LABEL_CONFIG;
    var fallbackEntry = DEFAULT_LABEL_CONFIG.labels[labelKey];
    var entry = (cfg.labels && cfg.labels[labelKey]) || fallbackEntry;
    if (!entry) return labelKey; // unknown key entirely - never throw, never render blank

    var overrides = entry.user_type_overrides || {};
    if (userType && Object.prototype.hasOwnProperty.call(overrides, userType)) {
        return overrides[userType];
    }
    return entry.default !== undefined ? entry.default : (fallbackEntry ? fallbackEntry.default : labelKey);
}

module.exports = { getDisplayLabel, DEFAULT_LABEL_CONFIG };
